import BannerStatic, { BannerType } from 'elem/compCommon/BannerStatic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';
import { SceneEmail } from '@elem/compCommon/SceneEmail';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const EU_SITES: string[] = ['eu', 'it', 'es', 'nl'];
    const LOCAL_SITES: string[] = ['uk', 'au', 'kr'];
    const IS_NA: boolean = ['us', 'ca'].includes(locale);
    const data: BannerType = {
        src: `/responsive/picture/vanlife-roadtrips/1${EU_SITES?.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        srcPad: `/responsive/picture/vanlife-roadtrips/1_768${EU_SITES?.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        srcMobile: `/responsive/picture/vanlife-roadtrips/1_768${EU_SITES?.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        alt: t('secA_title'),
        title: t('secA_title'),
        desc: t('secA_desc'),
        btnText: t('secA_btn'),
        link: '#vanlife-roadtrips-C',
        theme: locale === 'au' ? '' : 'black',
    };
    if (['au'].includes(locale)) {
        data.src = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716531551856/kv_au_1920.png';
        data.srcPad = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716531569890/kv_au_768.png';
        data.srcMobile = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716531569890/kv_au_768.png';
    }
    return (
        <div className={`vanlife-roadtrips-A ${css['vanlife-roadtrips-A']}`}>
            {IS_NA ? (
                <>
                    <EcoImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1764747351755/1.jpg'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1764747341221/1_768.jpg'}
                        alt={t('secA_title')}
                        aria-label={t('secA_title')}
                    />
                    <div className="info">
                        <p className="title">{t('secA_title')}</p>
                        <SceneEmail theme="black" type="RVING_ROAD_TRIPS" title={t('secA_title')} />
                    </div>
                </>
            ) : (
                <BannerStatic {...data} />
            )}
        </div>
    );
}
